// extracted by mini-css-extract-plugin
module.exports = {"separator":"horizontalLineText_separator__tI3Gn","line":"horizontalLineText_line__IXGb2","text":"horizontalLineText_text__DGeE0"};